import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { getISOMoeda } from 'lib/functions';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: { height: '100%' },
  content: { padding: 0 },
  image: {
    height: 48,
    width: 48
  },
  actions: { justifyContent: 'flex-end' }
}));

const FinanceiroSaldoPorConta = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const moeda = getISOMoeda(sessionStorage.getItem('moeda'));
  const saldosPorConta = rest.listaSaldosContas;

  let contas = saldosPorConta;

  return (
    <Card
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <CardHeader
        subtitle={`${contas.length} in total`}
        title="Saldos por conta"
      />

      <Divider />

      <CardContent className={classes.content}>
        <List>
          {contas.map((conta, i) => (
            <ListItem
              divider={i < contas.length - 1}
              key={conta.cdConta}
            >
              <ListItemAvatar>
                <img
                  alt="Product"
                  className={classes.image}
                  src={conta.imageUrl}
                />
              </ListItemAvatar>

              <ListItemText
                primary={conta.clienteConta}
                secondary={conta.saldoConta.toLocaleString(
                  moeda.abrevMoeda,
                  {
                    style: 'currency',
                    currency: moeda.isoMoeda
                  }
                )}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>

      <Divider />

      <CardActions className={classes.actions}></CardActions>
    </Card>
  );
};

FinanceiroSaldoPorConta.propTypes = {
  className: PropTypes.string
};

export default FinanceiroSaldoPorConta;